// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   FaProjectDiagram,
//   FaUserTie,
//   FaUsers,
//   FaCheckCircle,
// } from "react-icons/fa";

// const Dashboard = () => {
//   const [totalProjects, setTotalProjects] = useState(0);
//   const [userStats, setUserStats] = useState({
//     sitemasterCount: 0,
//     reviewerCount: 0,
//   });
//   const [reviewedCount, setReviewedCount] = useState(0);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const projectsRes = await axios.get(
//         "https://api.d2associates.in/daso//api/dashboard/total-projects"
//       );
//       const usersRes = await axios.get(
//         "https://api.d2associates.in/daso//api/dashboard/user-stats"
//       );
//       const reviewedRes = await axios.get(
//         "https://api.d2associates.in/daso//api/reviewed-count"
//       );

//       setTotalProjects(projectsRes.data.totalProjects);
//       setUserStats(usersRes.data);
//       setReviewedCount(reviewedRes.data.total_reviewed);
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Container (FORCE ONE ROW + SCROLL)
//   const containerStyle = {
//     display: "grid",
//     gridTemplateColumns: "repeat(4, minmax(220px, 1fr))",
//     gap: "20px",
//     padding: "20px",
//     overflowX: "auto", // 👈 prevents wrapping
//   };

//   // ✅ Card Style
//   const cardStyle = (gradient) => ({
//     minWidth: "220px", // 👈 prevents shrink
//     padding: "20px",
//     borderRadius: "16px",
//     background: gradient,
//     boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     transition: "0.3s",
//     cursor: "pointer",
//   });

//   const textStyle = {
//     color: "#333",
//   };

//   const numberStyle = {
//     fontSize: "28px",
//     fontWeight: "bold",
//     marginTop: "5px",
//   };

//   const iconStyle = {
//     fontSize: "38px",
//     opacity: 0.8,
//   };

//   return (
//     <div style={{ background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ padding: "20px", margin: 0 }}>Dashboard Overview</h2>

//       {loading ? (
//         <p style={{ padding: "20px" }}>Loading...</p>
//       ) : (
//         <div style={containerStyle}>
          
//           {/* Total Projects */}
//           <div
//             style={cardStyle("linear-gradient(135deg, #e0f7fa, #e1f5fe)")}
//             onMouseEnter={(e) =>
//               (e.currentTarget.style.transform = "translateY(-5px)")
//             }
//             onMouseLeave={(e) =>
//               (e.currentTarget.style.transform = "translateY(0)")
//             }
//           >
//             <div style={textStyle}>
//               <h4>Total Projects</h4>
//               <div style={numberStyle}>{totalProjects}</div>
//             </div>
//             <FaProjectDiagram style={{ ...iconStyle, color: "#0288d1" }} />
//           </div>

//           {/* Sitemasters */}
//           <div
//             style={cardStyle("linear-gradient(135deg, #e8f5e9, #f1f8e9)")}
//             onMouseEnter={(e) =>
//               (e.currentTarget.style.transform = "translateY(-5px)")
//             }
//             onMouseLeave={(e) =>
//               (e.currentTarget.style.transform = "translateY(0)")
//             }
//           >
//             <div style={textStyle}>
//               <h4>Sitemasters</h4>
//               <div style={numberStyle}>
//                 {userStats.sitemasterCount}
//               </div>
//             </div>
//             <FaUserTie style={{ ...iconStyle, color: "#2e7d32" }} />
//           </div>

//           {/* Reviewers */}
//           <div
//             style={cardStyle("linear-gradient(135deg, #fff3e0, #fff8e1)")}
//             onMouseEnter={(e) =>
//               (e.currentTarget.style.transform = "translateY(-5px)")
//             }
//             onMouseLeave={(e) =>
//               (e.currentTarget.style.transform = "translateY(0)")
//             }
//           >
//             <div style={textStyle}>
//               <h4>Reviewers</h4>
//               <div style={numberStyle}>{userStats.reviewerCount}</div>
//             </div>
//             <FaUsers style={{ ...iconStyle, color: "#ef6c00" }} />
//           </div>

//           {/* Reviewed Projects */}
//           <div
//             style={cardStyle("linear-gradient(135deg, #f3e5f5, #ede7f6)")}
//             onMouseEnter={(e) =>
//               (e.currentTarget.style.transform = "translateY(-5px)")
//             }
//             onMouseLeave={(e) =>
//               (e.currentTarget.style.transform = "translateY(0)")
//             }
//           >
//             <div style={textStyle}>
//               <h4>Reviewed Projects</h4>
//               <div style={numberStyle}>{reviewedCount}</div>
//             </div>
//             <FaCheckCircle style={{ ...iconStyle, color: "#6a1b9a" }} />
//           </div>

//         </div>
//       )}
//     </div>
//   );
// };

// export default Dashboard;
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   FaProjectDiagram,
//   FaUserTie,
//   FaUsers,
//   FaCheckCircle,
// } from "react-icons/fa";

// const Dashboard = () => {
//   const [totalProjects, setTotalProjects] = useState(0);
//   const [userStats, setUserStats] = useState({
//     sitemasterCount: 0,
//     reviewerCount: 0,
//   });
//   const [reviewedCount, setReviewedCount] = useState(0);

//   const [recentProjects, setRecentProjects] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const projectsRes = await axios.get(
//         "https://api.d2associates.in/daso//api/dashboard/total-projects"
//       );

//       const usersRes = await axios.get(
//         "https://api.d2associates.in/daso//api/dashboard/user-stats"
//       );

//       const reviewedRes = await axios.get(
//         "https://api.d2associates.in/daso//api/reviewed-count"
//       );

//       const recentRes = await axios.get(
//         "https://api.d2associates.in/daso//api/recent-assigned"
//       );

//       setTotalProjects(projectsRes.data.totalProjects);
//       setUserStats(usersRes.data);
//       setReviewedCount(reviewedRes.data.total_reviewed);
//       setRecentProjects(recentRes.data);

//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const containerStyle = {
//     display: "grid",
//     gridTemplateColumns: "repeat(4, minmax(220px, 1fr))",
//     gap: "20px",
//     padding: "20px",
//     overflowX: "auto",
//   };

//   const cardStyle = (gradient) => ({
//     minWidth: "220px",
//     padding: "20px",
//     borderRadius: "16px",
//     background: gradient,
//     boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     transition: "0.3s",
//     cursor: "pointer",
//   });

//   const textStyle = { color: "#333" };

//   const numberStyle = {
//     fontSize: "28px",
//     fontWeight: "bold",
//     marginTop: "5px",
//   };

//   const iconStyle = {
//     fontSize: "38px",
//     opacity: 0.8,
//   };

//   return (
//     <div style={{ background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ padding: "20px", margin: 0 }}>Dashboard Overview</h2>

//       {loading ? (
//         <p style={{ padding: "20px" }}>Loading...</p>
//       ) : (
//         <>
//           {/* CARDS */}
//           <div style={containerStyle}>
//             <div style={cardStyle("linear-gradient(135deg, #e0f7fa, #e1f5fe)")}>
//               <div style={textStyle}>
//                 <h4>Total Projects</h4>
//                 <div style={numberStyle}>{totalProjects}</div>
//               </div>
//               <FaProjectDiagram style={{ ...iconStyle, color: "#0288d1" }} />
//             </div>

//             <div style={cardStyle("linear-gradient(135deg, #e8f5e9, #f1f8e9)")}>
//               <div style={textStyle}>
//                 <h4>Sitemasters</h4>
//                 <div style={numberStyle}>{userStats.sitemasterCount}</div>
//               </div>
//               <FaUserTie style={{ ...iconStyle, color: "#2e7d32" }} />
//             </div>

//             <div style={cardStyle("linear-gradient(135deg, #fff3e0, #fff8e1)")}>
//               <div style={textStyle}>
//                 <h4>Reviewers</h4>
//                 <div style={numberStyle}>{userStats.reviewerCount}</div>
//               </div>
//               <FaUsers style={{ ...iconStyle, color: "#ef6c00" }} />
//             </div>

//             <div style={cardStyle("linear-gradient(135deg, #f3e5f5, #ede7f6)")}>
//               <div style={textStyle}>
//                 <h4>Reviewed Projects</h4>
//                 <div style={numberStyle}>{reviewedCount}</div>
//               </div>
//               <FaCheckCircle style={{ ...iconStyle, color: "#6a1b9a" }} />
//             </div>
//           </div>

//           {/* RECENT ASSIGNED PROJECTS (ONLY SCROLL ADDED) */}
//           <div style={{ padding: "20px" }}>
//             <h3>Recent Assigned Projects</h3>

//             <div
//               style={{
//                 marginTop: "10px",
//                 maxHeight: "250px",
//                 overflowY: "auto",
//                 paddingRight: "5px",
//               }}
//             >
//               {recentProjects.length === 0 ? (
//                 <p>No recent projects</p>
//               ) : (
//                 recentProjects.map((p) => (
//                   <div
//                     key={p.id}
//                     style={{
//                       background: "#fff",
//                       padding: "10px",
//                       marginBottom: "10px",
//                       borderRadius: "8px",
//                       boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
//                     }}
//                   >
//                     <b>{p.project_name}</b>
//                     <div>{p.bank_name} - {p.branch}</div>
//                     <small>
//                       {new Date(p.created_at).toLocaleString()}
//                     </small>
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default Dashboard;
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   FaProjectDiagram,
//   FaUserTie,
//   FaUsers,
//   FaCheckCircle,
// } from "react-icons/fa";

// const Dashboard = () => {
//   const [totalProjects, setTotalProjects] = useState(0);
//   const [userStats, setUserStats] = useState({
//     sitemasterCount: 0,
//     reviewerCount: 0,
//   });
//   const [reviewedCount, setReviewedCount] = useState(0);

//   const [recentProjects, setRecentProjects] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const projectsRes = await axios.get(
//         "https://api.d2associates.in/daso//dashboard/total-projects"
//       );

//       const usersRes = await axios.get(
//         "https://api.d2associates.in/daso//dashboard/user-stats"
//       );

//       const reviewedRes = await axios.get(
//         "https://api.d2associates.in/daso//reviewed-count"
//       );

//       const recentRes = await axios.get(
//         "https://api.d2associates.in/daso//recent-assigned"
//       );

//       setTotalProjects(projectsRes.data.totalProjects);
//       setUserStats(usersRes.data);
//       setReviewedCount(reviewedRes.data.total_reviewed);
//       setRecentProjects(recentRes.data);

//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const containerStyle = {
//     display: "grid",
//     gridTemplateColumns: "repeat(4, minmax(220px, 1fr))",
//     gap: "20px",
//     padding: "20px",
//     overflowX: "auto",
//   };

//   const cardStyle = (gradient) => ({
//     minWidth: "220px",
//     padding: "20px",
//     borderRadius: "16px",
//     background: gradient,
//     boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     transition: "0.3s",
//     cursor: "pointer",
//   });

//   const textStyle = { color: "#333" };

//   const numberStyle = {
//     fontSize: "28px",
//     fontWeight: "bold",
//     marginTop: "5px",
//   };

//   const iconStyle = {
//     fontSize: "38px",
//     opacity: 0.8,
//   };

//   const recentBoxStyle = {
//     marginTop: "10px",
//     maxHeight: "320px",
//     overflowY: "auto",
//     paddingRight: "10px",
//     borderRadius: "12px",
//   };

//   const recentCard = {
//     background: "#ffffff",
//     padding: "12px",
//     marginBottom: "10px",
//     borderRadius: "10px",
//     boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
//   };

//   // ✅ highlight style
//   const highlightText = {
//     background: "linear-gradient(90deg, #ffecd2, #fcb69f)",
//     padding: "2px 6px",
//     borderRadius: "6px",
//     fontWeight: "600",
//   };

//   return (
//     <div style={{ background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ padding: "20px", margin: 0 }}>Dashboard Overview</h2>

//       {loading ? (
//         <p style={{ padding: "20px" }}>Loading...</p>
//       ) : (
//         <>
//           {/* CARDS */}
//           <div style={containerStyle}>
//             <div style={cardStyle("linear-gradient(135deg, #e0f7fa, #e1f5fe)")}>
//               <div style={textStyle}>
//                 <h4>Total Projects</h4>
//                 <div style={numberStyle}>{totalProjects}</div>
//               </div>
//               <FaProjectDiagram style={{ ...iconStyle, color: "#0288d1" }} />
//             </div>

//             <div style={cardStyle("linear-gradient(135deg, #e8f5e9, #f1f8e9)")}>
//               <div style={textStyle}>
//                 <h4>Sitemasters</h4>
//                 <div style={numberStyle}>{userStats.sitemasterCount}</div>
//               </div>
//               <FaUserTie style={{ ...iconStyle, color: "#2e7d32" }} />
//             </div>

//             <div style={cardStyle("linear-gradient(135deg, #fff3e0, #fff8e1)")}>
//               <div style={textStyle}>
//                 <h4>Reviewers</h4>
//                 <div style={numberStyle}>{userStats.reviewerCount}</div>
//               </div>
//               <FaUsers style={{ ...iconStyle, color: "#ef6c00" }} />
//             </div>

//             <div style={cardStyle("linear-gradient(135deg, #f3e5f5, #ede7f6)")}>
//               <div style={textStyle}>
//                 <h4>Reviewed Projects</h4>
//                 <div style={numberStyle}>{reviewedCount}</div>
//               </div>
//               <FaCheckCircle style={{ ...iconStyle, color: "#6a1b9a" }} />
//             </div>
//           </div>

//           {/* RECENT ASSIGNED PROJECTS */}
//           <div style={{ padding: "20px" }}>
//             <h3>Recent Assigned Projects</h3>

//             <div style={recentBoxStyle}>
//               {recentProjects.length === 0 ? (
//                 <p>No recent projects</p>
//               ) : (
//                 recentProjects.map((p) => (
//                   <div key={p.id} style={recentCard}>
//                     <div>
//                       <span style={highlightText}>{p.project_name}</span>
//                     </div>

//                     <div style={{ marginTop: "5px" }}>
//                       <b>{p.bank_name}</b> - {p.branch}
//                     </div>

//                     <small style={{ color: "#666" }}>
//                       {new Date(p.created_at).toLocaleString()}
//                     </small>
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default Dashboard;

import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  FaProjectDiagram,
  FaUserTie,
  FaUsers,
  FaCheckCircle,
} from "react-icons/fa";

const Dashboard = () => {
  const [totalProjects, setTotalProjects] = useState(0);
  const [userStats, setUserStats] = useState({
    sitemasterCount: 0,
    reviewerCount: 0,
  });
  const [reviewedCount, setReviewedCount] = useState(0);

  const [recentProjects, setRecentProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const projectsRes = await axios.get(
        "https://api.d2associates.in/dashboard/total-projects"
      );

      const usersRes = await axios.get(
        "https://api.d2associates.in/dashboard/user-stats"
      );

      const reviewedRes = await axios.get(
        "https://api.d2associates.in/reviewed-count"
      );

      const recentRes = await axios.get(
        "https://api.d2associates.in/recent-assigned"
      );

      setTotalProjects(projectsRes.data.totalProjects);
      setUserStats(usersRes.data);
      setReviewedCount(reviewedRes.data.total_reviewed);
      setRecentProjects(recentRes.data);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


  const containerStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "20px",
    padding: "20px",
  };

  const cardStyle = (gradient) => ({
    minWidth: "220px",
    padding: "20px",
    borderRadius: "16px",
    background: gradient,
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    transition: "0.3s",
    cursor: "pointer",
  });

  const textStyle = { color: "#333" };

  const numberStyle = {
    fontSize: "28px",
    fontWeight: "bold",
    marginTop: "5px",
  };

  const iconStyle = {
    fontSize: "38px",
    opacity: 0.8,
  };

  const recentBoxStyle = {
    marginTop: "10px",
    maxHeight: "320px",
    overflowY: "auto",
    paddingRight: "10px",
    borderRadius: "12px",
  };

  const recentCard = {
    background: "#ffffff",
    padding: "12px",
    marginBottom: "10px",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  };

  const highlightText = {
    background: "linear-gradient(90deg, #ffecd2, #fcb69f)",
    padding: "2px 6px",
    borderRadius: "6px",
    fontWeight: "600",
  };

  return (
    <div style={{ background: "#f5f7fb", minHeight: "100vh" }}>
      <h2 style={{ padding: "20px", margin: 0 }}>Dashboard Overview</h2>

      {loading ? (
        <p style={{ padding: "20px" }}>Loading...</p>
      ) : (
        <>
          {/* CARDS */}
          <div style={containerStyle}>
            <div style={cardStyle("linear-gradient(135deg, #e0f7fa, #e1f5fe)")}>
              <div style={textStyle}>
                <h4>Total Projects</h4>
                <div style={numberStyle}>{totalProjects}</div>
              </div>
              <FaProjectDiagram style={{ ...iconStyle, color: "#0288d1" }} />
            </div>

            <div style={cardStyle("linear-gradient(135deg, #e8f5e9, #f1f8e9)")}>
              <div style={textStyle}>
                <h4>Sitemasters</h4>
                <div style={numberStyle}>{userStats.sitemasterCount}</div>
              </div>
              <FaUserTie style={{ ...iconStyle, color: "#2e7d32" }} />
            </div>

            <div style={cardStyle("linear-gradient(135deg, #fff3e0, #fff8e1)")}>
              <div style={textStyle}>
                <h4>Reviewers</h4>
                <div style={numberStyle}>{userStats.reviewerCount}</div>
              </div>
              <FaUsers style={{ ...iconStyle, color: "#ef6c00" }} />
            </div>

            <div style={cardStyle("linear-gradient(135deg, #f3e5f5, #ede7f6)")}>
              <div style={textStyle}>
                <h4>Reviewed Projects</h4>
                <div style={numberStyle}>{reviewedCount}</div>
              </div>
              <FaCheckCircle style={{ ...iconStyle, color: "#6a1b9a" }} />
            </div>
          </div>

          {/* RECENT ASSIGNED PROJECTS */}
          <div style={{ padding: "20px" }}>
            <h3>Recent Assigned Projects</h3>

            <div style={recentBoxStyle}>
              {recentProjects.length === 0 ? (
                <p>No recent projects</p>
              ) : (
                recentProjects.map((p) => (
                  <div key={p.id} style={recentCard}>
                    <div>
                      <span style={highlightText}>{p.project_name}</span>
                    </div>

                    <div style={{ marginTop: "5px" }}>
                      <b>{p.bank_name}</b> - {p.branch}
                    </div>

                    <small style={{ color: "#666" }}>
                      {new Date(p.created_at).toLocaleString()}
                    </small>
                  </div>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
